import * as yup from 'yup'

export const societyBoardCreateSchema = yup
  .object({
    role: yup.string().required(),
    userId: yup.string().required(),
  })
  .required()
